import React, { Component, Fragment } from "react";
import _ from "lodash";
import { ParallaxProvider } from "react-skrollr";
import { Element } from "react-scroll";
import { Header, Footer } from "../../components";
import { Helmet } from "react-helmet";
import { withRedux } from "../../hoc";
import { switchLanguage } from "../../actions/language";
import { switchLocation } from "../../actions/location";
import { initHome } from "../../actions/home";
import { assetsPath } from "../../utils";
import Gallery from "./Gallery";
import Welcome from "./Welcome";
import Promotion from "./Promotion";

const page = "home";

const mapStateToProps = state => {
  return {
    ...state
  };
};

const actionToProps = {
  switchLanguage,
  switchLocation,
  initHome
};

@withRedux(mapStateToProps, actionToProps)
export default class Home extends Component {
  componentDidMount() {
    this.setLanguage(this.props.match.params.language);
    this.fetchData();
  }
  componentDidUpdate(prevProps) {
    const currentLanguage = prevProps.match.params.language;
    const nextLanguage = this.props.match.params.language;
    if (currentLanguage !== nextLanguage) {
      this.setLanguage(nextLanguage);
    }
  }
  setLanguage = language => {
    this.props.actions.switchLanguage(language);
  };
  fetchData = () => {
    this.props.actions.initHome();
  };
  renderSectionWithId = (component, id) => {
    return (
      <Element name={id}>
        <section id={id}>{component}</section>
      </Element>
    );
  };
  render() {
    const pageData = _.get(this.props, `${page}.data`);
    const isMobile = _.get(this.props, "device.isMobile");
    const currentLanguage = _.get(this.props, "language.currentActive");
    return (
      <ParallaxProvider
        init={{
          smoothScrollingDuration: 500,
          smoothScrolling: true,
          forceHeight: false
        }}
      >
        <Fragment>
          <Helmet>
            <title>Laguna</title>
          </Helmet>
          <Header
            mainLogo={`${assetsPath()}/images/logo-laguna-property.svg`}
            hasSubHeader={false}
            language={currentLanguage}
          />
          <video autoPlay muted loop id="myVideo">
            <source src="https://lagunaproperty.com/vdo/21486733-5.mp4" type="video/mp4" />
          </video>
          <div className="main-content laguna-village-residences-page">
            {this.renderSectionWithId(
              <Gallery isRenderTitle {..._.get(pageData, `gallery`)} page={page} />,
              "Gallery"
            )}
            {this.renderSectionWithId(
              <Welcome
                title={_.get(pageData, "concept.title")}
                subContent={_.get(pageData, "concept.subContent")}
                content={_.get(pageData, "concept.content")}
                button={_.get(pageData, "concept.button")}
                page={page}
              />,
              "Welcome"
            )}
            {this.renderSectionWithId(
              <Promotion
                title={_.get(pageData, "promotion.title")}
                content={_.get(pageData, "promotion.content")}
                button={_.get(pageData, "promotion.button")}
                page={page}
              />,
              "Promotion"
            )}
            {this.renderSectionWithId(
              <Fragment>
                <Footer />
              </Fragment>
            )}
          </div>
        </Fragment>
      </ParallaxProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js